import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import RentalDashboardLayer from '../components/RentalDashboardLayer'

const RentalDashboardPage = () => {
  return (
    <MasterLayout>
        <Breadcrumb title='Rental Dashboard' />
        <RentalDashboardLayer />
    </MasterLayout>
  )
}

export default RentalDashboardPage


